import Menu from './menu';
import MenuItem from './menuItem';
import './menu.less';
Menu.MenuItem = MenuItem;
export default Menu;